/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:53:01]
Permissions to update outside the main branch: [false]
*/

import { DropDown, ValidatedDropDownList, ValidatedInput } from '@finbeat/react-toolkit';
import { t } from 'i18next';
import { PrescrFilter as PrescrFilterType } from 'models/api/prescr';
import { Col, Row } from 'reactstrap';

type PrescrFilterProps = {
    prescrRules: DropDown[];
    prescrRulesLoading: boolean;
    tradeOrgs: DropDown[];
    tradeOrgsLoading: boolean;
};

const PrescrFilter = ({
    prescrRules,
    tradeOrgs,
    prescrRulesLoading,
    tradeOrgsLoading,
}: PrescrFilterProps) => {
    return (
        <>
            <Row>
                <Col>
                    <ValidatedInput<PrescrFilterType>
                        name="id"
                        type="number"
                        id="b-filter-id"
                        label={t('BackOfficeId')}
                    />
                </Col>
                <Col>
                    <ValidatedDropDownList<PrescrFilterType>
                        name="type"
                        items={prescrRules}
                        label={t('BackOfficeRuleType')}
                        isLoading={prescrRulesLoading}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <ValidatedDropDownList<PrescrFilterType>
                        name="tradeOrgId"
                        items={tradeOrgs}
                        label={t('BackOfficeTradeOrgShort')}
                        isLoading={tradeOrgsLoading}
                    />
                </Col>
            </Row>
        </>
    );
};

export default PrescrFilter;
